import React from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";

const LoaderContainer = styled.div`
	width: 100%;
	height: 100%;
	min-height: 10rem;
	min-width: 10rem;
	margin: auto;
	display: flex;
	align-items: center;
	justify-content: center;

	@keyframes spinner {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
	.loading-spinner {
		width: 50px;
		height: 50px;
		border: 5px solid #f3f3f3; /* Light grey */
		border-top: 5px solid ${theme.color.green}; /* Black */
		border-radius: 50%;
		animation: spinner 1.5s linear infinite;
	}
`;

export default function QueryLoader() {
	return (
		<LoaderContainer>
			<div className="loading-spinner"></div>
		</LoaderContainer>
	);
}
